import { GET_CHAT_LIST, SET_CHAT_LOADING_SKELETON, UPDATE_CHAT_LAST_MESSAGE } from "../actions/types";

const initialState = {
  channelList: [],
  isChatLoading: true
};
export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {

    case GET_CHAT_LIST:
      return {
        ...state,
        channelList: payload,
      };

    case UPDATE_CHAT_LAST_MESSAGE:
      return {
        ...state,
        channelList: state.channelList.map(c =>
          c.chat._id === payload.chatId
            ? { ...c, lastMessage: payload.lastMessage }
            : c
        ),
        // setChats(prev =>
        //   prev.map(c =>
        //     c.chat._id === msg.chat ? { ...c, lastMessage: msg } : c
        //   )
        // );
      };


    case SET_CHAT_LOADING_SKELETON:
      return {
        ...state,
        isChatLoading: payload,
      };
    default:
      return state;
  }
}
